import { DashedFocusBorder } from 'components/Common/DashedFocusBorder';
import styled from 'styled-components';

export const Container = styled.div`
    padding: 16px;
`;

export const WidgetHeader = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-item: center;
    padding: 0px 8px 8px 0;
`;

export const CSSEventItem = styled.div<{ status: string }>`
    background-color: ${(props) =>
        props.status == 'accepted'
            ? props.theme.color.greenL90
            : props.status == 'pending'
            ? props.theme.color.white
            : props.theme.color.raspberryL95};
    display: flex;
    flex-direction: column;
    padding: ${(props) => props.theme.space.md}px;
    border-radius: ${(props) => props.theme.space.sm}px;
    margin-bottom: 10px;
    box-shadow: 0 0 0 1px
        ${(props) =>
            props.status == 'accepted'
                ? props.theme.color.greenL90
                : props.status == 'declined'
                ? props.theme.color.raspberryL95
                : props.theme.color.yellow};
`;

export const CSSEventItemA = styled.a<{ status: string }>`
    background-color: ${(props) =>
        props.status == 'accepted'
            ? props.theme.color.greenL90
            : props.status == 'pending'
            ? props.theme.color.white
            : props.theme.color.raspberryL95};
    display: flex;
    flex-direction: column;
    padding: ${(props) => props.theme.space.md}px;
    border-radius: ${(props) => props.theme.space.sm}px;
    margin-bottom: 10px;
    box-shadow: 0 0 0 1px
        ${(props) =>
            props.status == 'accepted'
                ? props.theme.color.greenL90
                : props.status == 'declined'
                ? props.theme.color.raspberryL95
                : props.theme.color.yellow};
    transition: box-shadow 0.4s;
    &:hover {
        color: ${(props) => props.theme.color.black};
        text-decoration: none;
        box-shadow: 0 0 0 2px
            ${(props) =>
                props.status == 'accepted'
                    ? props.theme.color.green
                    : props.status == 'declined'
                    ? props.theme.color.raspberry
                    : props.theme.color.yellow};
    }
    ${DashedFocusBorder()}
`;

export const CssEventItemStatus = styled.div<{ status: string }>`
    width: ${(props) => props.theme.size.sm + 2}px;
    height: ${(props) => props.theme.size.sm + 2}px;
    border-radius: ${(props) => props.theme.size.sm + 2}px;
    margin-right: ${(props) => props.theme.size.sm}px;
    background-color: ${(props) =>
        props.status == 'accepted'
            ? props.theme.color.green
            : props.status == 'declined'
            ? props.theme.color.raspberry
            : props.theme.color.yellow};
`;

export const Status = styled.div`
    display: flex;
    align-item: row;
    padding-top: ${(props) => props.theme.space.sm}px;
    align-items: center;
`;
